module.exports = __webpack_public_path__ + "media/images/pro/6-9a4ae9bd1300de826be9df71d6267053.png";